



















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Column, LoraParser } from "@/types/core";
import TimestampAgo from "@/components/TimestampAgo.vue";
import EnterpriseId from "@/components/EnterpriseId.vue";
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";

@Component({
  components: {
    MobileFriendlyRow,
    TimestampAgo,
    EnterpriseId
  }
})
export default class LoraParserRowMobile extends Vue {
  @Prop({ default: () => {},  type: Object}) loraParser!: LoraParser;
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    {colName: 'id / name',
      colStyle:{'flex-grow':1, 'min-width': '160px', 'font-weight':'bold'},
      colKey:'loraParserId'
    }
  ]

  goToLoraParserPage(loraParserId:string) {
    this.$router.push({name:'lora-parser-edit', params:{loraParserId: this.loraParser.loraParserId}});
  }

}
